module.exports = __webpack_public_path__ + "img/指纹容量.10bfe6ff.png";